/** Update  the setting for all projects!!! */

/**
 * 
 * @param {function} dispatch 
 * @param {string} settingsKey 
 * @param {boolean} previewOnly 
 */
export const fixAllSettings = async (fn_cls, dispatch, settingsKey, previewOnly) => {
  const result = await fn_cls.fixAllSettings(settingsKey, previewOnly)
  console.log('settingsKey', settingsKey, result)
  dispatch({ type: 'showPreview', dispatch, previewInfo: result });
} 